import * as z from "zod";
import type {
  PortalSettingsPatch,
  ReturnsPortalSettingsSource,
} from "./portal-settings-source";

export const returnEditingSettingsShape = {
  returnEditing: z.object({
    allowCustomerCancelReturn: z.boolean(),
    allowCustomerEditExchangeAddress: z.boolean(),
  }),
};

export type ReturnEditingSettings = z.infer<
  z.ZodObject<typeof returnEditingSettingsShape>
>;

export function returnEditingSettingsFromTeam({
  settings,
}: ReturnsPortalSettingsSource): ReturnEditingSettings {
  const { returns } = settings;
  return {
    returnEditing: {
      allowCustomerCancelReturn:
        returns?.returnEditing?.allowCustomerCancelReturn ?? false,
      allowCustomerEditExchangeAddress:
        returns?.returnEditing?.allowCustomerEditExchangeAddress ?? false,
    },
  };
}

export function returnEditingTeamPatch({
  returnEditing,
}: ReturnEditingSettings): PortalSettingsPatch {
  return {
    set: {
      "returns.returnEditing.allowCustomerCancelReturn":
        returnEditing.allowCustomerCancelReturn,
      "returns.returnEditing.allowCustomerEditExchangeAddress":
        returnEditing.allowCustomerEditExchangeAddress,
    },
    unset: [],
  };
}
